import { TimeForIncidence } from '~/prix/types/presets/time'

export default function checkIfTimeIsRealtime(
  time: TimeForIncidence | null | undefined,
): boolean | null {
  if (!time || !time.endDate) {
    return null // Not enough information to determine if the time is realtime
  }
  const today = new Date().toISOString().split('T')[0]
  return time.endDate && (time.endDate as string) >= today
}
